import { z } from 'zod';
import { coords, id, constrainedStrings } from './common';

export const connectorStyleOptions = ['SOLID', 'DOTTED', 'DASHED'] as const;
export const arrowTypeOptions = ['NONE', 'SINGLE', 'DOUBLE'] as const;
export const flowDirectionOptions = ['forward', 'backward', 'bidirectional'] as const;
export const arrowDirectionOptions = ['forward', 'backward'] as const;


export const anchorSchema = z.object({
  id,
  ref: z
    .object({
      item: id,
      anchor: id,
      tile: coords
    })
    .partial()
});

export const connectorSchema = z.object({
  id,
  description: constrainedStrings.description.optional(),
  color: id.optional(),
  width: z.number().optional(),
  style: z.enum(connectorStyleOptions).optional(),
  anchors: z.array(anchorSchema),
  arrowType: z.enum(arrowTypeOptions).optional(),
  fadeEnds: z.boolean().optional(),
  arrowDirection: z.enum(arrowDirectionOptions).optional(),
    // NEW: Flow animation properties
  flowEnabled: z.boolean().optional(),
  flowSpeed: z.number().min(0.5).max(3).optional(),
  flowParticleCount: z.number().int().min(1).max(10).optional(),
  flowParticleSize: z.number().int().min(4).max(16).optional(),
  flowDirection: z.enum(flowDirectionOptions).optional(),
  // Layer properties
  visible: z.boolean().optional(),
  locked: z.boolean().optional(),
  zIndex: z.number().optional()
});